<template>
  <b-card class="mb-3">
    <b-media>
      <b-img height="150" slot="aside" :src="imageSrc" :alt="imageAlt"></b-img>
      <span class="d-inline-block mb-2">
        <strong>{{ item.object }}</strong>
        <strong class="text-danger" v-show="item.externalObject">(Fremdpublikation)</strong>
        <span> vom </span>
        <strong>{{ formattedDate }}</strong>: {{ item.text }}
      </span>
      <h3>
        <router-link :to="{ name: 'mediadetail', params: { index: item.index, slug: item.slug }}" class="text-dark">{{ item.headline }}</router-link>
      </h3>
      <div class="mb-1 text-muted">{{ item.subline }}</div>
      <p class="mb-2">{{ shortedContent }}</p>
      <router-link :to="{ name: 'mediadetail', params: { index: item.index, slug: item.slug }}">Mehr...</router-link>
    </b-media>
  </b-card>
</template>

<script>
  import { DateSmallDecorator, truncate } from "../helper";

  export default {
    name: 'SearchResultSingle',
    props: [ 'item' ],
    computed: {
      shortedContent: function () {
        return truncate(this.item.content, 120)
      },
      formattedDate: function () {
        return DateSmallDecorator(this.item.date)
      },
      imageSrc: function () {
        return '/dl/' + this.item.id + '/thumbnail.jpg'
      },
      imageAlt: function () {
        return this.item.object + ' vom ' + DateSmallDecorator(this.item.date)
      }
    },
    methods: {
      DateSmallDecorator,
      truncate
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchResultSingle.vue